"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidVinCharacters = exports.invalidVinMatches = exports.licensePlateStates = void 0;
var licensePlateStates = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY"
];
exports.licensePlateStates = licensePlateStates;
var invalidVinMatches = [
    {
        invalidChar: 'O',
        possibleMatches: ['0']
    },
    {
        invalidChar: 'I',
        possibleMatches: ['1']
    },
    {
        invalidChar: 'Q',
        possibleMatches: ['G', '6']
    }
];
exports.invalidVinMatches = invalidVinMatches;
var invalidVinCharacters = invalidVinMatches.map(function (x) { return x.invalidChar; });
exports.invalidVinCharacters = invalidVinCharacters;
